module.exports = __webpack_public_path__ + "static/media/img2.ff91bb30.png";